export const COOKIE_NAME = "app_session_id";
export const ONE_YEAR_MS = 1000 * 60 * 60 * 24 * 365;

/** Stabiler Bezeichner für den LCS-GmbH-Betrieb in der `betriebe`-Tabelle. */
export const LCS_BETRIEB_NAME = "LCS GmbH";
